import { useContext, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { AppContext } from '@CONTEXTS';
import { useHistory } from 'react-router-dom';

const AppRouter = (props) => {
  const history = useHistory();
  const { dispatch } = useContext(AppContext);

  useEffect(() => {
    if (history.location.pathname === props.path) {
      dispatch({ type: 'SET_TITLE', payload: props.title });
    }
    dispatch({ type: 'SET_PATH', payload: history.location.pathname });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [dispatch, history.location, props.path, props.title]);

  return <Route {...props} />;
};

export default AppRouter;
